"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.summarizeReconciliation = summarizeReconciliation;
exports.reconcileBank = reconcileBank;
const money_1 = require("../money");
/**
 * يلخص مطابقة بنكية: الرصيد السابق + (مدين − دائن) ما ظهر فى الكشف. حساب البنك
 * مدين الطبيعة، فالإيداع مدين والسحب دائن. لا يفرض التوازن — العرض يحتاج الفرق
 * وهو غير صفر أثناء الاختيار.
 */
function summarizeReconciliation(input) {
    const chosen = new Set(input.cleared);
    const lines = input.available.filter((line) => chosen.has(line.id));
    const clearedDeposits = money_1.Money.sum(lines.map((line) => line.debit));
    const clearedWithdrawals = money_1.Money.sum(lines.map((line) => line.credit));
    const clearedBalance = money_1.Money.of(input.previousBalance)
        .add(clearedDeposits)
        .sub(clearedWithdrawals);
    return {
        clearedDeposits,
        clearedWithdrawals,
        clearedBalance,
        difference: money_1.Money.of(input.statementBalance).sub(clearedBalance),
    };
}
/**
 * يتحقق من مطابقة قبل إتمامها، ويجمع كل المشاكل: كشف بعد آخر مطابقة، سطور معروفة غير
 * مكررة بتاريخ لا يتجاوز الكشف، وفرق صفرى. التسوية (مصاريف بنكية، فوائد) لا تُنشأ
 * هنا — تُسجَّل مستندًا أولاً ثم تُطابق كأى سطر.
 */
function reconcileBank(input) {
    const issues = [];
    if (input.previousDate !== null && input.statementDate <= input.previousDate) {
        issues.push({
            code: 'RECONCILIATION_DATE_NOT_AFTER',
            message: 'statement date must be after the last reconciliation',
            details: { previousDate: input.previousDate },
        });
    }
    const byId = new Map(input.available.map((line) => [line.id, line]));
    const seen = new Set();
    input.cleared.forEach((id, lineIndex) => {
        if (seen.has(id)) {
            issues.push({
                code: 'RECONCILIATION_LINE_DUPLICATE',
                message: 'line chosen twice',
                lineIndex,
            });
            return;
        }
        seen.add(id);
        const line = byId.get(id);
        if (!line) {
            issues.push({
                code: 'RECONCILIATION_LINE_UNKNOWN',
                message: 'line is not an unreconciled entry on this bank account',
                lineIndex,
            });
        }
        else if (line.postingDate > input.statementDate) {
            issues.push({
                code: 'RECONCILIATION_LINE_AFTER_STATEMENT',
                message: 'line is dated after the statement',
                lineIndex,
            });
        }
    });
    const summary = summarizeReconciliation({ ...input, cleared: [...seen] });
    if (!summary.difference.isZero()) {
        issues.push({
            code: 'RECONCILIATION_OUT_OF_BALANCE',
            message: 'statement balance does not equal the reconciled balance',
            details: { difference: summary.difference.toString() },
        });
    }
    if (issues.length > 0)
        return { ok: false, issues };
    return { ok: true, value: summary };
}
//# sourceMappingURL=reconciliation.js.map